





































import { Vue, Component, Prop } from 'vue-property-decorator';
import { unescapeHtml } from '@/utils/common';
import { CosBoardsBoardCodeSummary } from 'ncp-api-supporter';
import ArticleNewBadge from '@/components/root/parts/ArticleNewBadge.vue';

// isTopFixed: 상단 고정 게시물 여부 (게시물 API 응답으로 내려오나 supporter 타입에는 아직 미정의)
type SellerTipArticle = CosBoardsBoardCodeSummary & { isTopFixed?: boolean };

@Component({ components: { ArticleNewBadge } })
export default class ArticleList extends Vue {
  @Prop({ required: true })
  private readonly title!: string;
  // 전체보기 링크 (카테고리 필터가 포함된 목록 페이지)
  @Prop({ required: true })
  private readonly detailLinkBase!: string;
  // 개별 게시물 링크 base (viewPath가 뒤에 붙는다 / 쿼리스트링 없음)
  @Prop({ required: true })
  private readonly articleLinkBase!: string;
  @Prop({ required: true })
  private readonly articles!: SellerTipArticle[];
  @Prop({ default: '게시물이 없습니다.' })
  private readonly emptyText!: string;
  private unescapeHtml = unescapeHtml;
}
